import { ErrorContext } from "@configura/web-ui";
import React, { Component, ReactNode } from "react";
import styles from "./index.module.css";

interface Props {
	children: ReactNode;
}

interface State {
	error: Error | undefined;
}

class ErrorBoundary extends Component<Props, State, string> {
	public state: State = {
		error: undefined,
	};

	public static getDerivedStateFromError(error: Error): State {
		// Update state so the next render will show the fallback UI.
		return { error };
	}

	public render(): React.ReactNode {
		const { error } = this.state;

		if (error === undefined) {
			return this.props.children;
		}

		return (
			<div className={styles.errorContainer}>
				<div className={styles.errorMessage}>{error.message}</div>
			</div>
		);
	}
}
ErrorBoundary.contextType = ErrorContext;

export default ErrorBoundary;
